<!--
 * @Description: 常规工作/日常事务 公文
 * @Author: PF
 * @Date: 2023-02-23 17:07:24
 * @LastEditors: PF
 * @LastEditTime: 2023-07-28 16:41:30
-->

<template>
  <div>
    <el-dialog class="wp80 hp80" v-model="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">公文</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="shenpihome">
        <div class="nei_rong">
          <el-tabs v-model="activeNames" class="demo-tabs">
            <el-tab-pane label="待办" :name="0">
              <el-table :data="wblData" v-loading="loading" height="100%" border stripe>
                <!-- 冻结列-Left BEGIN -->
                <el-table-column label="序号" type="index" width="80" fixed align="center" />
                <el-table-column label="来文标题" prop="lwbt" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
                <el-table-column label="收发员" prop="sfrxm" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
                <!-- 冻结列-Left END -->
                <el-table-column label="操作时间" width="160" prop="czsj" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
                <el-table-column label="派发类型" prop="pflx" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" >
                  <template #default="scope">
                    <span v-if="scope.row.pflx === 0">登记</span>
                    <span v-if="scope.row.pflx === 1">拟办</span>
                    <span v-if="scope.row.pflx === 2">批办</span>
                    <span v-if="scope.row.pflx === 3">承办</span>
                    <span v-if="scope.row.pflx === 4">分发</span>
                    <span v-if="scope.row.pflx === 5">传阅</span>
                    <span v-if="scope.row.pflx === 9">办结</span>
                  </template>
                </el-table-column>
                <el-table-column label="意见" prop="yj" align="center" />
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="通过" :name="1">
              <el-table :data="tgData" v-loading="loading" height="100%" border stripe>
                <!-- 冻结列-Left BEGIN -->
                <el-table-column label="序号" type="index" width="80" fixed align="center" />
                <el-table-column label="来文标题" prop="lwbt" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
                <el-table-column label="收发员" prop="sfrxm" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
                <!-- 冻结列-Left END -->
                <el-table-column label="操作时间" width="160" prop="czsj" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
                <el-table-column label="派发类型" prop="pflx" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" >
                  <template #default="scope">
                    <span v-if="scope.row.pflx === 0">登记</span>
                    <span v-if="scope.row.pflx === 1">拟办</span>
                    <span v-if="scope.row.pflx === 2">批办</span>
                    <span v-if="scope.row.pflx === 3">承办</span>
                    <span v-if="scope.row.pflx === 4">分发</span>
                    <span v-if="scope.row.pflx === 5">传阅</span>
                    <span v-if="scope.row.pflx === 9">办结</span>
                  </template>
                </el-table-column>
                <el-table-column label="意见" prop="yj" align="center" />
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="拒绝" :name="2">
              <el-table :data="jjData" v-loading="loading" height="100%" border stripe>
                <!-- 冻结列-Left BEGIN -->
                <el-table-column label="序号" type="index" width="80" fixed align="center" />
                <el-table-column label="来文标题" prop="lwbt" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
                <el-table-column label="收发员" prop="sfrxm" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
                <!-- 冻结列-Left END -->
                <el-table-column label="操作时间" width="160" prop="czsj" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
                <el-table-column label="派发类型" prop="pflx" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" >
                  <template #default="scope">
                    <span v-if="scope.row.pflx === 0">登记</span>
                    <span v-if="scope.row.pflx === 1">拟办</span>
                    <span v-if="scope.row.pflx === 2">批办</span>
                    <span v-if="scope.row.pflx === 3">承办</span>
                    <span v-if="scope.row.pflx === 4">分发</span>
                    <span v-if="scope.row.pflx === 5">传阅</span>
                    <span v-if="scope.row.pflx === 9">办结</span>
                  </template>
                </el-table-column>
                <el-table-column label="意见" prop="yj" align="center" />
              </el-table>
            </el-tab-pane>
          </el-tabs>
          <!-- <el-tabs v-model="activeNames" class="demo-tabs">
            待办 开始
            <el-tab-pane label="待办" :name="1">
            </el-tab-pane>
            待办 结束
            已办 开始
            <el-tab-pane label="已办" :name="2">
            </el-tab-pane>
            已办 结束
            待阅 开始
            <el-tab-pane label="待阅" :name="3">
            </el-tab-pane>
            待阅 结束
            已阅 开始
            <el-tab-pane label="已阅" :name="4">
            </el-tab-pane>
            已阅 结束
          </el-tabs> -->
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button @click="openList=false;homeCloseWindow('openReturn', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch } from 'vue'
import { homeCloseWindow, loadList, actionPost } from '@/api/common.js'

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

const activeNames = ref(0)
const wblData = ref()
const tgData = ref()
const jjData = ref()
const loading = ref(false)
const bindTable = async () => {
  wblData.value = []
  tgData.value = []
  jjData.value = []
  loading.value = true
  const o = {
    url: '/api/v2/bangong/gongwenshouwendan/jiaozhigong',
    data: { order: 'zt', sort: 'asc' }
  }
  actionPost(o).then((res) => {
    loading.value = false
    if (res.data) {
      res.data.forEach(element => {
        if (element.zt === 0) {
          wblData.value.push(element)
        }
        if (element.zt === 1) {
          tgData.value.push(element)
        }
        if (element.zt === 2) {
          jjData.value.push(element)
        }
      })
    }
  })
}
// const dataGrid = ref({
//   parms: {},
//   data: [],
//   pagination: {},
//   loading: false,
//   orderBy: { prop: 'zt', order: 'ascending' },
//   multipleSelection: [],
//   sortChange: function (column) {
//     dataGrid.value.orderBy.prop = column.prop
//     dataGrid.value.orderBy.order = column.order
//     bindTable()
//   },
//   selectionChange: function (selection) {
//     dataGrid.value.multipleSelection = selection.map((item) => item.id)
//   }
// })
// const bindTable = async (pageNo, pageSize) => {
//   loadList({
//     url: '/api/v2/bangong/gongwenshouwendan/jiaozhigong',
//     pageNo: pageNo || 1,
//     pageSize: pageSize || 100,
//     dataGrid: dataGrid.value,
//     loadSuccess: function (res) {
//       dataGrid.value.multipleSelection = []
//     }
//   })
// }
const openList = ref(false)

watch(
  () => props.open,
  () => {
    if (props.open === 'gongwen') {
      openList.value = true
      bindTable()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)
</script>
